module.exports = __webpack_public_path__ + "img/view.65ddf283.png";